import { FeaturesState } from './reducer';

export const selectFeaturesState = (state: any): FeaturesState =>
  state.auth.isAuthenticated
    ? state.features.fetchFeatures
    : state.features.fetchUnauthFeatures;

export const selectFeatures = (state: any): FeaturesState['response'] =>
  selectFeaturesState(state).response || {};

export const selectIsFetching = (state: any) =>
  selectFeaturesState(state).isFetching;

export const selectError = (state: any) => selectFeaturesState(state).error;

export const selectLastFetchAttempt = (state: any) =>
  selectFeaturesState(state).lastFetchAttempt;
